import { Payload, payloadSchema } from 'embedded/api/in/messages/Payload';
import { JSONSchemaType } from 'ajv';

export type LogoutMessagePayload = Payload;

export const logoutPayloadSchema: JSONSchemaType<LogoutMessagePayload> = {
    type: 'object',
    properties: {
        ...payloadSchema.properties,
    },
    required: [],
    additionalProperties: false,
};
